import { render } from "./ShippingPickUp.vue?vue&type=template&id=198c65e9"
import script from "./ShippingPickUp.vue?vue&type=script&lang=js"
export * from "./ShippingPickUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__